export type isLoadingState = {
    isLoading:boolean
}


export const isLoading:isLoadingState={
    isLoading:false
}